module.exports = {
    //Page Login
    "login.title": "เข้าใช้งานระบบสารสนเทศบริหารการศึกษา",
    "login.admin_desc": "สำหรับผู้ดูแลระบบใช้งานเท่านั้น ผู้ใช้งานทั่วไปกรุณาเข้าสู่ระบบด้วย KU All-Login",
    "login.username": "บัญชีผู้ใช้",
    "login.password": "รหัสผ่าน",
    "LOGIN__FORGOT_PWD": "ลืมรหัสผ่าน",
    "LOGIN__LOGIN": "เข้าสู่ระบบ",
    "LOGIN__PLACEHOLDER_LOGIN": "เช่น b63xxxxxxxx หรือ regxxx",
    "LOGIN__PLACEHOLDER_PWD": "รหัสผ่าน",
    "LOGIN__ANNOUNCEMENT": "ข่าวประชาสัมพันธ์ทั่วไป",
    "common.ok": "ตกลง",
    "common.cancel": "ยกเลิก",
    "common.back": "ย้อนกลับ",
    "common.backUrl": "กลับหน้าหลัก",
    "common.backFirst": "กลับหน้าแรก",
    "common.academicYear": "ปีการศึกษา",
    "common.loadingData": "กรุณารอสักครู่",
    "common.pleaes.select": "กรุณาเลือก",
    "common.first.semester": "ภาคต้น",
    "common.second.semester": "ภาคปลาย",
    "common.summer.semester": "ภาคฤดูร้อน",
    "common.year": "ปี",
    "COMMON_WELCOME_HOME_PAGE": "ยินดีต้อนรับเข้าสู่ระบบลงทะเบียนนิสิต",
    "COMMON_TOTAL": "ทั้งหมด",
    "COMMON__ALL": "ทั้งหมด",
    "COMMON_SUBJECT": "วิชา",
    "COMMON_SECTION": "หมู่",
    "finStd.feeRateNotFound": "ไม่พบข้อมูลค่าธรรมเนียม กรุณาติดต่อเจ้าหน้าที่",
    "finStd.installmentNotFound": "ไม่พบข้อมูลประเภทการแบ่งชำระ กรุณาติดต่อเจ้าหน้าที่",
    "finStd.pageTitle": "การเงินนิสิต",
    "finStd.tabEnrollType": "เลือกรูปแบบ",
    "finStd.tabFinStd": "การเงิน",
    "finStd.comment1": "โปรดเลือกรูปแบบการลงทะเบียน",
    "finStd.comment2": "ยอดที่แสดงเป็นยอดที่ยังไม่หักส่วนลดและเงินกู้ที่ได้รับ",
    "finStd.comment3": "โปรดเลือกประเภทการชำระเงิน",
    "finStd.comment3_optional": "ประเภทการชำระเงินที่จะแสดง",
    "finStd.notTimeToRegistration": "ไม่อยู่ช่วงของปฏิทินการศึกษา สามารถเลือกรูปแบบการลงทะเบียนได้ระหว่างวันที่",
    "finStd.probation": "ไม่สามารถเลือกรูปแบบการลงทะเบียนได้ เนื่องจากนิสิตมีเกรดเฉลี่ยต่ำกว่า 2.00 กรุณาติดต่ออาจารย์ที่ปรึกษา",
    "finStd.financeNotFound": "ไม่พบข้อมูลประวัติการชำระเงินนิสิต",
    "finStd.stdLoanInfo": "นิสิตมีรายชื่อยื่นกู้ยืมกองทุนเพื่อการศึกษา กรอ./กยศ. สามารถชำระเงินในภายหลังได้",
    "finStd.stdLoanInsInfo": "นิสิตมีรายชื่อยื่นกู้ยืมกองทุนเพื่อการศึกษา กรอ./กยศ. ไม่สามารถแบ่งชำระเป็นงวดได้",
    "finStd.invalidStdTypeWord1": "สถานภาพนิสิต",
    "finStd.invalidStdTypeWord2": "ไม่สามารถทำรายการได้ กรุณาติดต่อสำนักบริหารการศึกษา",
    "ENROLL__SEARCH_SUBJECT": "ค้นหารายวิชาเพื่อลงทะเบียน",
    "enroll.academic.year": "ปีการศึกษา",
    "enroll.semester": "ภาคการศึกษา",
    "ENROLLMENT_DATE": "นิสิตสามารถลงทะเบียนเรียนได้ตามวันเวลาดังนี้",
    "ENROLLMENT_DATE_PRE": "นิสิตสามารถลงทะเบียนล่วงหน้าได้ตามวันเวลาดังนี้",
    "ENROLLMENT_DATE_PRE_ENG": "ลงทะเบียนล่วงหน้า เฉพาะวิชาภาษาอังกฤษ 01355102 และ 01355103",
    "std.search.student": "ค้นหานิสิต",
    "ANNOUNCEMENT_EMPTY": "ยังไม่มีประกาศรายวิชาจากอาจารย์ผู้สอน",
    "ANNOUNCEMENT_SUBJECT": "ประกาศรายวิชา",
    "CLASS_SCHEDULE_TITLE": "ตารางเรียน/สอบ",
    "CLASS_SCHEDULE_CLASS": "ตารางเรียน",
    "CLASS_SCHEDULE_MIDTERM": "สอบกลางภาค",
    "CLASS_SCHEDULE_FINAL": "สอบปลายภาค ",
    "CLASS_SCHEDULE_NOT_FOUND": "ไม่พบตารางเรียน",
    "SUBJECT__QUOTA": "จำนวนรับ",
    "SUBJECT__REGISTERED": "ลงทะเบียนแล้ว",
    "SUBJECT__OPEN_SUBJECT": "รายวิชาที่เปิดให้ลงทะเบียน",
    // "SUBJECT__OPEN_MAJOR_YEAR"               : "สาขาชั้นปีมีสิทธิ์" ,
    "COMMON__CONTACT_TEACHER": "ติดต่อผู้สอน",
    "COMMON__VIEW_ANNOUNCEMENT": "ดูประกาศ",
    "COMMON__VIEW_DETAIL": "ดูรายละเอียด",
    "COMMON__CLASS_SCHEDULE_ROOM": "ห้อง",
    "COMMON__T_TEACHER": "อ.ผู้สอน",
    "COMMON__SEARCH_SUBJECT": "ค้นหารายวิชา",
    "COMMON__SEARCH": "ค้นหา",
    "COMMON__CLEAR": "ล้าง",
    "COMMON__CAMPUS": "สถานที่จัดการเรียนการสอน",
    "COMMON__SECTION": "หมู่เรียน",
    "COMMON__NO_DATA_TRY_AGAIN": "ไม่พบข้อมูล กรุณาทำรายการใหม่อีกครั้ง",
    "COMMON__ENROLLED": "ลงทะเบียนแล้ว",
    "COMMON__CREDIT": "หน่วยกิต",
    "COMMON__TEACHER": "อาจารย์ผู้สอน",
    "COMMON__ENTER_PHONE_NUMBER": "ระบุเบอร์โทรศัพท์ที่ติดต่อได้",
    "COMMON__BAHT": "บาท",
    "COMMON__COPY_DOC": "สำเนา",
    "COMMON__ORIGINAL_DOC": "ต้นฉบับ",
    "COMMON__FULL": "เต็ม",
    "COMMON__SUCCESS": "สำเร็จ",
    "COMMON__APPROVE": "เห็นชอบ",
    "COMMON__DISAPPROVE": "ไม่เห็นชอบ",
    "FNSTD__SV_DL_LEAVE_OF_ABSENCE": "บันทึกและดาวน์โหลดใบลาพักการศึกษา",
    "FNSTD__PRINT_REQUEST_FORM": "1. พิมพ์ใบคำร้อง (หากกดบันทึกจะมีใบคำร้องปรากฏ)",
    "FNSTD__PER_INSTALLMENT": "งวดละ",
    "FNSTD__INSTALLMENTS": "งวด",
    "FNSTD__PAID_AMOUNT": "ยอดชำระแล้ว",
    "FNSTD__PENDING_AMOUNT": "ยอดค้างชำระ",
    "FNSTD__DUE_AMOUNT": "ยอดเงินที่ต้องชำระ",
    "FNSTD__TOTAL_PENDING_AMOUNT": "ยอดค้างชำระทั้งหมด",
    "FNSTD__FEE_NOT_PAID": "ยังไม่ได้ชำระค่าธรรมเนียม",
    "FNSTD__CHECK_STATUS": "ตรวจสอบสถานะ",
    "FNSTD__PRINT_INVOICE": "พิมพ์ใบแจ้งหนี้",
    "FNSTD__PRINT_RECEIPT": "พิมพ์ใบเสร็จ",
    "FNSTD__STEP3_SCAN_QR": "STEP 3: สแกน QR ชำระเงิน",
    "FNSTD__CLICK_TO_MAX_QR": "กดที่รูป QR เพื่อขยายและสแกนชำระเงิน",
    "FNSTD__SCAN_TO_PAY": "สแกนเพื่อจ่ายหนี้",
    "FNSTD__CHECK_PAYMENT_STATUS": "ปรับปรุงสถานะการชำระเงิน",
    "FNSTD__INVOICE_DETAILS": "รายละเอียดใบแจ้งหนี้",
    "FNSTD__INVOICE_NO": "เลขที่แจ้ง",
    "FNSTD__REF_NO_1": "Ref1:",
    "FNSTD__REF_NO_2": "Ref2:",
    "FNSTD__CHK_PAYMENT_STATUS": "สถานะการชำระเงิน",
    "FNSTD__CREATE_DATE": "วันที่สร้างรายการ",
    "FNSTD__UPDATE_DATE": "วันที่ปรับปรุงรายการ",
    "ENROLL__ENROLL": "ลงทะเบียนเรียน",
    "ENROLL__SUBJECTS_ENROLLED": "รายวิชาที่ลงทะเบียนสำเร็จ",
    "ENROLL__SUBJECTS_AWAITING_APPROVAL": "รายวิชาที่รอเห็นชอบ",
    "ENROLL__NO_SUBJECTS_AWAITING_APPROVAL": "ไม่พบรายวิชาที่รอเห็นชอบ",
    "ENROLL__WITHDRAW": "ถอน",
    "ENROLL__SELECT_SECTION": "เลือกหมู่เรียน",
    "ENROLL__AVAILABLE_SECTIONS": "หมู่เรียนที่สามารถลงทะเบียนได้",
    "ENROLL__SUBJECT_CODE_NAME": "รหัสวิชา, ชื่อวิชา",
    "ENROLL__PLS_SELECT_BOTH_LEC_LAB": "กรุณาเลือกหมู่เรียน บรรยาย และ ปฏิบัติ",
    "ENROLL__CONFIRM_ENROLL": "ยืนยันการลงทะเบียน",
    "ENROLL__CANNOT_ENROLL_FUNDAMENTAL": "ไม่สามารถลงทะเบียนได้เนื่องจากยังไม่ผ่านวิชาพื้นฐานก่อนหน้า",
    "ENROLL__CANNOT_ENROLL_PRE_CO": "ไม่สามารถลงทะเบียนได้เนื่องจากไม่ผ่านวิชา Pre",
    "ENROLL__CHECKING_PRE_CO": "กำลังตรวจสอบ Pre-Co",
    "ENROLL__ALREADY_ENROLL_GRADE_IS": "ไม่สามารถลงทะเบียนซ้ำได้ ผ่านการลงทะเบียนและได้รับผลการเรียน",
    "ENROLL__CANNOT_ENROLL_ALREADY_ENROLLED": "ไม่สามารถลงทะเบียนซ้ำได้ มีรายการลงทะเบียนในรายวิชานี้แล้ว",
    "ENROLL__NO_SECTIONS_FOUND": "ไม่พบหมู่เรียนที่สามารถลงทะเบียนได้ เนื่องจากหมู่เรียนยังไม่เปิดให้ลงทะเบียน หรือ สาขาวิชาของนิสิตไม่ตรงกับเงื่อนไขที่กำหนด",
    "ENROLL__CHECKING_AVAILABLE_SECTIONS": "กำลังตรวจสอบหมู่เรียนที่สามารถลงทะเบียนได้",
    "ENROLL__PLS_SELECT_LAB": "กรุณาเลือกหมู่เรียนปฏิบัติ",
    "ENROLL__ENROLLMENT_CONFIRMED": "ยืนยันลงทะเบียนเรียน",
    "ENROLL__SUBJECTS": "รายวิชา",
    "ENROLL__ENROLLMENT_SUCCESSFUL": "ลงทะเบียนสำเร็จ",
    "ENROLL__CANNOT_PROCESS": "ไม่สามารถทำรายการได้ ",
    "ENROLL__THERE_R_ENROLLMENTS_IN": "มีการลงทะเบียนเรียนในรายวิชา",
    "ENROLL__ERM_TYPE_NOT_SELECTED": "ไม่พบข้อมูลการเลือกรูปแบบการลงทะเบียนเรียน",
    "ENROLL__TRANSACTION_CANT_BE_PROCESS": "ไม่สามารถทำรายการได้",
    "ENROLL__SUBJECT_WITHDRAWAL_CF": "ยืนยันถอนรายวิชา",
    "ENROLL__GPAX": "เกรดเฉลี่ย",
    "CHKGRD__CHK_GRD_RESULT": "ตรวจสอบผลการเรียน",
    "CHKGRD__CUMULATIVE_CREDIT": "หน่วยกิตสะสม",
    "CHKGRD__GPA": "เกรดเฉลี่ย",
    "CHKGRD__SUM_GPA": "เกรดเฉลี่ยสะสม",
    "COMMON__SUM": "รวม",
    "ENROLL__COURSES_NEED_ENROLLED": "รายวิชาที่ต้องลงทะเบียน",
    "ENROLL__NOT_FOUND": "ไม่พบรายวิชาที่ลงทะเบียน",
    "ENROLL__WARNING_PDF": "หากนิสิตลงทะเบียนเรียนครบทุกวิชาแล้ว กรุณาบันทึกผลการลงทะเบียน (PDF) เพื่อใช้เป็นหลักฐาน !!!",
    "COMMON__CONFIRM": "ยืนยัน",
    "ENROLL__CHECK_ENROLL_RESULTS": "ตรวจสอบผลการลงทะเบียน",
    "ENROLL_WITHDRAW_RECEIVED_GRADE": "ถอนติด",
    "COMMON__CHECKING_DATA": "กำลังตรวจสอบข้อมูล",
    "COMMON__LECTURE": "บรรยาย",
    "COMMON__LAB": "ปฏิบัติ",
    "COMMON__WAITING_APPROVE": "รอพิจารณา",
    "ENROLL__SUBJECTS_WAITING_APPROVE": "รายวิชาที่รอพิจารณา",
    "FNSTD__SLIDE_TO_ORIGINAL": "สไลด์เพื่อเลือกพิมพ์ต้นฉบับ",
    "FNSTD__SLIDE_TO_COPY": "สไลด์เพื่อเลือกพิมพ์สำเนา",
    "ENROLL__DISAPPROVAL": "รายวิชาที่ไม่เห็นชอบ",
    "ENROLL__RESULTS": "ผลการลงทะเบียน",
    "ENROLL__PRINT_RESULTS": "พิมพ์ผลลงทะเบียน",
    "ENROLL__STD_LOANS": "พิมพ์หลักฐานเงินกู้",
    "FNSTD__DISCOUNT": "ส่วนลด",
    "FNSTD__SCHOLARSHIPS": "ทุนการศึกษา",
    "FNSTD__LOAN": "เงินกู้",
    "FNSTD__TOTAL_PAID": "ยอดชำระแล้วทั้งหมด",
    "FNSTD__TOTAL_OUTSTANDING": "ยอดค้างชำระทั้งหมด",
    "ENROLL__ELIGIBLE_MAJOR": "สาขาชั้นปีที่มีสิทธิ์",
    "ENROLL__INELIGIBLE_MAJOR": "สาขาชั้นปีที่ไม่มีสิทธิ์",
    "ENROLL__ENROLL_": "ลงทะเบียน",
    "FNSTD__PAYMENT_DETAIL": "รายละเอียดการชำระเงิน",
    "FNSTD__PAYMENT_STATUS": "สถานะการชำระเงิน",
    "MENU__ENROLLED_HISTORY": "ประวัติการลงทะเบียน",
    "MENU__CLASS_EXAM": "ตารางเรียน/ตารางสอบ",
    "MENU__OPEN_SUBJECT": "วิชาที่เปิดให้ลงทะเบียน",
    "MENU__ENROLL_TYPE_FIN": "เลือกรูปแบบ/การเงิน",
    "MENU_ADD_DROP": "ลงทะเบียน/เพิ่ม-ถอน",
    "MENU__ENROLL_RESULT": "ผลการลงทะเบียน",
    "MENU__GRADE": "ตรวจสอบผลการเรียน",
    "MENU__DASHBOARD": "สถิติ",
    "FNSTD__RECEIPT_NO": "เลขที่ใบเสร็จ",
    "MENU__STUDENT_NEWS": "ข่าวสารนิสิต",
    "FNSTD__PAYMENT_METHODS": "ช่องทางการชำระเงิน",
    "FNSTD__PATMENT_DATE": "วันที่ชำระ",
    "FNSTD__RECEIPT_ORI": "ใบเสร็จ (ต้นฉบับ)",
    "FNSTD__ORI_PUBLISHER": "ผู้พิมพ์ต้นฉบับ",
    "FNSTD__ORI_PUBLISH_DATE": "วันที่พิมพ์ต้นฉบับ",
    "FNSTD__PAYEE": "ผู้รับเงิน",
    "COMMON_MSG_1": "หากต้องการค้นหาข้อมูล",
    "COMMON_MSG_2": "สามารถค้นหาได้จากรหัสนิสิตหรือชื่อนิสิต",
    "COMMON__MSG_SEARCH_1": "หากต้องการค้นหาข้อมูล",
    "COMMON__MSG_SEARCH_2": "สามารถค้นหาได้จากรหัสหรือชื่อ",
    "COMMON__TEACHER_COURSE_NOT_FOUND": "ไม่พบรายวิชาของอาจารย์ผู้สอน",
    "COMMON__CREATE_BY": "ผู้ทำรายการ",
    "COMMON__ADD": "เพิ่ม",
    "COMMON__CREATE_DATE": "วันที่ทำรายการ",
    "COMMON__DATA_NOT_FOUND": "ไม่พบข้อมูล",
    "COMMON__PLZ_TRY_AGAIN": "กรุณาทำรายการใหม่อีกครั้ง",
    "COMMON_MSG_SUB_1": "หากต้องการค้นหารายวิชาที่เปิดให้ลงทะเบียน",
    "COMMON_MSG_SUB_2": "ให้ค้นหาจากรหัสวิชา, ​ชื่อรายวิชา",
    "COMMON_SEARCHING": "กำลังค้นหา...",
    "COMMON__ENROLLMENT_SYSTEM_KU": "ระบบสารสนเทศบริหารการศึกษา มหาวิทยาลัยเกษตรศาสตร์",
    "FNSTD__PAID": "ชำระแล้ว",
    "FNSTD__NOT_YET_PAID": "ยังไม่ชำระ",
    "MSG_ENROLLMENT_TYPE_NOT_FOUND": "ไม่พบข้อมูลการเลือกรูปแบบการลงทะเบียนเรียน",
    "MSG_PLEASE_SELECT_ENROLLMENT_TYPE": "กรุณาตรวจสอบข้อมูลที่เมนู",
    "BTN_SELECT_ENROLLMENT_TYPE": "เลือกรูปแบบการลงทะเบียน",
    "MSG_FEE_FOUND": "นิสิตมีรายการค่าธรรมเนียมค้างชำระ",
    "MSG_CHECK_FIN": "กรุณาตรวจสอบข้อมูลการเงินนิสิต หรือ ค่าปรับจากหน่วยงานภายนอก ที่เมนู สถิติ",
    "BTN_UNPAID": "ตรวจสอบรายการค้างชำระ",
    "MSG_NOT_TIME_TO_ENROLL": "ไม่อยู่ในช่วงลงทะเบียน",
    "MSG_CAN_ENROLL": "สามารถลงทะเบียนได้ระหว่างวันที่",
    "BTN_CANCEL_PAYMENT": "ยกเลิกรูปแบบการชำระเงิน",
    "FNSTD__PARTIAL_PAYMENT": "ชำระบางส่วน",
    "FNSTD__WITHDRAWABLE": "เบิกได้",
    "FNSTD__POSTPONED": "ผ่อนผัน",
    "FNSTD__ON_INSTALLMENT": "ผ่อนชำระ",
    "MSG_CONFIRM_SELECT_PAYMENT": "ยืนยันการเลือกรูปแบบชำระเงิน",
    "MSG_ENROLLMENT_SUCCESSFUL": "เลือกรูปแบบการลงทะเบียนสำเร็จ",
    "MSG_INSTALLMENT_AMOUNT": "งวดละ",
    "MSG_TYPE": "ประเภท",
    "COMMON__ANNOUNCED_ON": "ประกาศเมื่อ",
    "FNSTD__FULL_EDU_FEE_REG": "ค่าธรรมเนียมการศึกษาแบบเหมาจ่าย (ภาคปกติ)",
    "COMMON__LATEST_ON": "ล่าสุดเมื่อ",
    "COMMON__BY": "โดย",
    "FNSTD__PAYMENT_SUCCESSFUL": "คุณได้ทำการชำระเงินเรียบร้อยแล้ว",
    "MSG__STD_CONTACT_LEAVE": "ระบุเบอร์โทรศัพท์ที่ติดต่อได้",
    "MSG__STD_CONTACT_LEAVE_DETAILS_1": "1. พิมพ์ใบคำร้อง (หากกดบันทึกจะมีใบคำร้องปรากฏ)",
    "MSG__STD_CONTACT_LEAVE_DETAILS_2": "2. ยื่นคำร้องขอลาพักการศึกษาผ่าน อาจารย์ที่ปรึกษา หัวหน้าภาควิชา คณบดีต้นสังกัด ให้ความเห็นชอบ",
    "MSG__STD_CONTACT_LEAVE_DETAILS_3": "3. ส่งคำร้องที่ผ่านความเห็นชอบไปยังสำนักบริหารการศึกษา",
    "MSG__STD_CONTACT_LEAVE_DETAILS_4": "4. สำนักบริหารการศึกษาจะดำเนินการบันทึกเข้าระบบ",
    "MSG__STD_ATTENTION_HEADER": "นิสิตโปรดทราบ!!!",
    "BTN__STD_SAVE_AND_DOWNLOAD": "บันทึกและดาวน์โหลดใบลาพักการศึกษา",
    "MSG__STD_ATTENTION_DETAILS_1": "กรณีที่นิสิตมีการเปลี่ยนแปลงรูปแบบการลงทะเบียนเรียน หรือเปลี่ยนแปลงประเภทการชำระเงิน นิสิตจำเป็นต้องใช้ QR Code ตัวใหม่ในการชำระเงิน โดยระบบจะทำการ Generate QR ให้หลังนิสิตกดปุ่ม",
    "MSG__STD_ATTENTION_DETAILS_2": "หากนิสิตใช้ QR Code เดิมในการชำระเงิน ระบบจะไม่สามารถตัดชำระเงินได้สำเร็จ!",
    "MSG__STD_ATTENTION_DETAILS_3": "กดปุ่ม",
    "MSG__STD_ATTENTION_DETAILS_4": "หากต้องการทำรายการต่อ",
    "COMMON__AND": "และ",
    "COMMON__OR": "หรือ",
    "COMMON__AND_OR": "และ/หรือ",
    "INFO_DOC_FOR_WITHDRAWAL": "เอกสารประกอบการเบิก",
    "INFO_DOC_FOR_WITHDRAWAL_DETAIL_1": "1. ใบเสร็จรับเงิน KU2 สามารถพิมพ์",
    "INFO_DOC_FOR_WITHDRAWAL_DETAIL_2": "ได้เพียง 1 ครั้งเท่านั้น หากพิมพ์ครั้งถัดไปจะเป็น",
    "INFO_DOC_FOR_WITHDRAWAL_DETAIL_3": "สำเนา",
    "INFO_DOC_FOR_WITHDRAWAL_DETAIL_4": "ทั้งนี้ หากนิสิตไม่สามารถพิมพ์ต้นฉบับได้ สามารถติดต่อขอรับต้นฉบับได้ที่หน่วยทะเบียนของวิทยาเขตที่นิสิตสังกัด",
    "INFO_DOC_FOR_WITHDRAWAL_DETAIL_5": "2. นิสิตที่ผู้ปกครองสามารถเบิกค่าเล่าเรียนบุตรได้ ให้ดาวน์โหลดเอกสารประกอบการเบิกได้ที่ ",
    "ENROLL__COURSE_HV_TO_ENR_WITH": "รายวิชานี้ต้องลงทะเบียนพร้อมกับรายวิชา",
    "ENROLL__WOULD_LIKE_TO_ENROLL": "ต้องการลงทะเบียน รายวิชา",
    "ENROLL__PLS_SEL_C_TOGETHER": "กรุณาเลือกรายวิชาที่ต้องการลงทะเบียนร่วมกัน",
    "ENROLL__PLS_SEL_C": "กรุณาเลือกรายวิชา",
    "ENROLL__AT": "เวลา",
    "MSG__ENROLL_TYPE_1": "ไม่อยู่ในช่วงเลือกรูปแบบการลงทะเบียน",
    "MSG__ENROLL_TYPE_2": "สามารถเลือกรูปแบบการลงทะเบียนได้ระหว่างวันที่",
    "MSG__ENROLL_TYPE_3": "ไม่พบปฎิทินการศึกษาตามกำหนดการ",
    "MSG__ENROLL_TYPE_4": "ของวันเลือกประเภทการลงทะเบียนและชำระเงิน",
    "MSG__ENROLL_TYPE_5": "กรุณาติดต่อเจ้าหน้าที่สำนักบริหารการศึกษา",
    "CHKGRD__PRINT_GRD_RESULT": "พิมพ์ผลการเรียน",
    "ENROLL__PLS_SEL_CREDIT_2_ER": "กรุณาเลือกจำนวนหน่วยกิตในการลงทะเบียน",
    "ENROLL__FN_X_DT_HAS_DUP": "วันเวลาสอบปลายภาคตรงกับวิชา",
    "ENROLL__MD_X_DT_HAS_DUP": "วันเวลาสอบกลางภาคตรงกับวิชา",
    "ENROLL__LRN_X_DT_HAS_DUP": "วันเวลาเรียนตรงกับวิชา",
    "ENROLL__ENR_NOT_IN_PERIOD": "ไม่อยู่ในช่วงการลงทะเบียน",
    "ENROLL__AT_PERIOD_DROP_ONLY": "อยู่ในช่วงการถอนรายวิชาเท่านั้น",
    "ENROLL__CREDIT_AMOUNT_HAS_OVER": "จำนวนหน่วยกิตเกินกว่ากำหนด",
    "ENROLL__BECAUSE_SEL_MAINTAIN_TYPE": "เนื่องจากเลือกรูปแบบการลงทะเบียนเรียนแบบรักษาสถานภาพ",
    "ENROLL__SECTION_FULL": "เนื่องจากหมู่เรียนเต็ม",
    "ENROLL__ENROLLMENT_TYPE": "เปลี่ยนประเภทการลงทะเบียน",
    "ENROLL__CREDIT_AMOUNT": "เปลี่ยนจำนวนหน่วยกิต",
    "COMMON__PROCESSING": "กำลังดำเนินการ...",
    "ENROLL__LATE_ENROLL": "ลงทะเบียนล่าช้า",
    "ENROLL__DOESNT_MEET_CONDITION": "ไม่ตรงเงื่อนไขให้ลงทะเบียน",
    "ENROLL__OP_ER_IN_PERIOD_ONLY": "เปิดลงทะเบียนช่วงล่าช้าเท่านั้น",
    "COMMON__ALREADY": "แล้ว",
    "ENROLL__CANT_PRCSS_ER_NT_FOUND": "ไม่สามารถทำรายการได้เนื่องจากไม่พบรายการลงทะเบียนเรียน",
    "ENROLL__PLS_SELECT_LEC": "กรุณาเลือกหมู่เรียนบรรยาย",
    "ENROLL__THERE_R_ER_IN_GRP_OF": "มีการลงทะเบียนเรียนในกลุ่มวิชาพิเศษแล้ว",
    "ENROLL__EARLY_REGISTER": "ลงทะเบียนล่วงหน้า",
    "ENROLL__SEARCH_SUBJECT_PRE": "ค้นหารายวิชาเพื่อลงทะเบียนล่วงหน้า",
    "COMMON__SUCCESSFUL": "ลงทะเบียนสำเร็จ",
    "ERRESULT__SEARCH_STUDENT": "ค้นหานิสิต",
    "ERRESULT__SEARCH_FACULTY": "ค้นหาคณะ",
    "ERRESULT__SEARCH_MAJOR": "ค้นหาสาขา",
    "ERRESULT__SPECIFY_STD_NAME_CODE": "ระบุรหัสนิสิต, ชื่อนิสิต",
    "ERRESULT__SPECIFY_FACULTY": "ระบุคณะ",
    "ERRESULT__SPECIFY_MAJOR": "ระบุสาขา",
    "ANNOUNCEMENT__NO_SUBJECT": "ประกาศจากอาจารย์ผู้สอน",
    "COMMON__SUCCESSFUL_STATUS": "ทำรายการสำเร็จ",
    "COMMON__TOTAL": "จำนวน",
    "BTN__SAVE": "บันทึก",
    "MENU__COURSES_ADD_DROP_ANNOUNCE": "รายวิชา (อนุมัติเพิ่ม-ถอน / ประกาศ)",
    "MENU__STUDENTS_UNLOCK_CONSIDER": "นิสิต (ปลดล็อครอพินิจ)",
    "MENU__STUDENTS_ENROLL_RESULT": "นิสิต (ตรวจสอบผลการลงทะเบียน)",
    "COMMON__REMARK": "หมายเหตุ",
    "SUBJECT__QUOTA__TOTAL": "จำนวนรับทั้งหมด",
    "SUBJECT__REGISTERED__TOTAL": "ลงทะเบียนแล้วทั้งหมด",
    "PERSONS": "คน",
    "ENROLL__CANT_DROP_COUSE_CREDIT": "ไม่สามารถถอนรายวิชาได้ต่ำกว่าหน่วยกิตที่กำหนด",
    "ENROLL__CANNOT_BE_PROCESS": "การทำรายการผิดพลาด",
    "ENROLL__WITHDRAW_W": "ถอนติด W",
    "LOGIN__CONTACT_US": "ติดต่อเรา",
    "COMMON__NAME_SURNAME": "ชื่อ-นามสกุล",
    "PROFILE__PERSONAL_INFO": "ข้อมูลส่วนบุคคล",
    "PROFILE__FATHER_INFO": "ข้อมูลบิดา",
    "PROFILE__MOTHER_INFO": "ข้อมูลมารดา",
    "PROFILE__EDU_INFO": "ข้อมูลการศึกษา",
    "PROFILE__STATUS_HISTORY": "ประวัติการเปลี่ยนแปลงสถานภาพนิสิต",
    "PROFILE__TRANSFER_HISTORY": "ประวัติการโอนย้ายนิสิต",
    "PROFILE__REGISTERED_ADDRESS": "ที่อยู่ตามสำเนาทะเบียนบ้าน",
    "PROFILE__PRESENT_ADDRESS": "ที่อยู่ปัจจุบัน",
    "PROFILE__ID_NO": "บัตรประจำตัวประชาชน",
    "PROFILE__NAME_SURNAME_TH": "ชื่อ-นามสกุล (TH)",
    "PROFILE__NAME_SURNAME_EN": "ชื่อ-นามสกุล (EN)",
    "PROFILE__DATE_OF_BIRTH": "วันเกิด",
    "PROFILE__NATIONALITY": "สัญชาติ",
    "PROFILE__RELIGION": "ศาสนา",
    "PROFILE__MOBILE": "โทรศัพท์มือถือ",
    "PROFILE__TEL": "เบอร์โทรศัพท์ติดต่อ",
    "PROFILE__BARCODE_LIB": "Barcode ห้องสมุด",
    "PROFILE__PHYSICAL_CONDITION": "สถานภาพร่างกาย",
    "PROFILE__GENERAL_INFO": "ข้อมูลทั่วไป",
    "PROFILE__ADDRESS": "ที่อยู่",
    "PROFILE__GRADE_RESULT": "ผลการศึกษา",
    "PROFILE__EDUCATION_LEVEL": "ระดับการศึกษา",
    "PROFILE__STD_STATUS": "สถานภาพนิสิต",
    "PROFILE__STD_TYPE": "สถานะนิสิต",
    "PROFILE__DEGREE_NAME": "ชื่อปริญญา",
    "PROFILE__COURSE": "หลักสูตร",
    "PROFILE__FACULTY": "คณะ",
    "PROFILE__DEPARTMENT": "ภาควิชา",
    "PROFILE__MAJOR": "สาขา",
    "PROFILE__ADMISSION_DATE": "วันที่รับเข้า",
    "PROFILE__ADMISSION_TYPE": "ช่องทางการรับเข้า",
    "PROFILE__GET_IN_PROJECT": "โครงการที่รับเข้า",
    "PROFILE__WELFARE_LIST": "สิทธิ์ในการเบิกสวัสดิการ",
    "PROFILE__PROGRAM": "แผนการศึกษา",
    "PROFILE__MAJOR_SUBJECT": "วิชาเอก",
    "PROFILE__ATTENDED_DATE": "วันที่เข้าศึกษา",
    "PROFILE__EDU_STATUS_OLD": "สถานภาพการศึกษา (เดิม)",
    "PROFILE__EFFECTIVE_DATE": "วันที่มีผลบังคับใช้",
    "PROFILE__RECORDED_BY": "บันทึกโดย",
    "PROFILE__CAUSE": "สาเหตุ",
    "PROFILE__REASON_DATE": "วันที่บันทึกเหตุผล",
    "PROFILE__DOCUMENT_S": "เอกสารประกอบ",
    "PROFILE__EDU_STATUS_PRESENT": "(สถานภาพล่าสุด)",
    "PROFILE__EDU_STATUS": "สถานภาพการศึกษา",
    "COMMON__ADVISOR": "อาจารย์ที่ปรึกษา",
    "PROFILE__APPROVED_DATE": "วันที่อนุมัติ",
    "PROFILE__TRANSACTION_DATE": "วันที่ทำรายการ",
    "PROFILE__COURSE_NEW": "หลักสูตร (ใหม่)",
    "PROFILE__COURSE_OLD": "หลักสูตร (เก่า)",
    "PROFILE__ADDRESS_NO": "บ้านเลขที่",
    "PROFILE__VILLAGE_NO": "หมู่ที่",
    "PROFILE__BUILDING_NO": "อาคาร",
    "PROFILE__FLOOR": "ชั้น",
    "PROFILE__LANE": "ตรอก/ซอย",
    "PROFILE__ROAD": "ถนน",
    "PROFILE__SUB_DISTRICT": "ตำบล/แขวง",
    "PROFILE__DISTRICT": "อำเภอ/เขต",
    "PROFILE__PROVINCE": "จังหวัด",
    "PROFILE__COUNTRY": "ประเทศ",
    "PROFILE__POSTAL_CODE": "รหัสไปรษณีย์",
    "PROFILE__HOME_PHONE": "โทรศัพท์บ้าน",
    "ENROLL__UNLOCKED": "ปลดล็อก",
    "COMMENT__ENROLLED": "ไม่สามารถเปลี่ยนแปลงประเภทการลงทะเบียนได้ เนื่องจากนิสิตมีรายวิชาที่ลงทะเบียนค้างอยู่",
    "FIN__QR_EXPIRED1": "QR Code นี้ หมดอายุแล้ว ชำระได้อีกครั้งในวันที่ ",
    "FIN__QR_EXPIRED2": " ของเดือนถัดไป",
    "FIN__QR_INFO": "QR Code นี้จะหมดอายุ ภายในวันที่ ",
    "ENROLL__CHANGE_SECTION": "เปลี่ยนหมู่",
    "ENROLL__CHANGE_SECTION_INPROCESS1": "อยู่ระหว่างการดำเนินการ",
    "ENROLL__CHANGE_SECTION_INPROCESS2": "ขอเปลี่ยนหมู่",
    "ENROLL__REG_NOT_ANNOUNCED": "ยังไม่ประกาศให้นิสิตลงทะเบียน",
    "ENROLL__SEC_CLOSED": "หมู่เรียนถูกปิด",
    "PROFILE__GENDER": "เพศ",
    "PROFILE__PASSPORT_NO": "หมายเลขหนังสือเดินทาง",
    "ENROLL__SUBJECT_MAPPING": "สามารถเรียนทดแทนวิชา",
    "SUBJECT__OPEN": "รายชื่อวิชาที่เปิดสอนทั้งหมด",
    "PROFILE__RESTORATION_DATE": "วันที่คืนสถานภาพ",
    "PROFILE__RESTORATION_UPDATE_BY": "สถานภาพโดย",
    "PROFILE__RESTORATION_REMARK": "สาเหตุการสถานภาพ",
    "PROFILE__UPDATE_DT": "วันที่ปรับปรุงข้อมูล",
    "ENROLL__CANNOT_ENROLL_MAX": "เนื่องจากมีจำนวนนิสิตตามเงื่อนไขย่อยตาม สาขา-ชั้นปี ครบถ้วนแล้ว",
    "ENROLL__CANNOT_ENROLL_MAX_HEADER": "ไม่สามารถลงทะเบียนเรียนในหมู่นี้ได้",
    "FIN__STATUS_PAYMENT_NOT_S": "หากชำระแล้วและสถานะยังไม่เปลี่ยนทันที ให้ตรวจสอบอีกครั้งในวันทำการวันถัดไป",
    "FIN__STATUS_PAYMENT_IS_S": "ให้ตรวจสอบในวันทำการวันถัดไปเท่านั้น",
    "FIN__STATUS_PAYMENT": "สถานะการชำระเงิน",
    "QR_CODE_PAYMENT_EXPIRED": "Expired",
    "QR_CODE_PAYMENT_SYSTEM_NOT_CONNECT": "ไม่สามารถเชื่อมต่อระบบ QR Code ได้ กรุณาลองอีกครั้งภายหลัง",
    "FNSTD__PRINT_CREDIT_NOTE": "ใบลดหย่อน ฯ",
    "ENROLL__SECTION_TYPE": "ประเภทหมู่เรียน : ",
    "ANNOC__GENERAL_INFO": "ทั่วไป",
    //page masterfee
    "MASTER_FEE__FEE_TITLE": "จัดการ Config การเงิน",
    "MASTER_FEE__FEE_DETAIL_TITLE": "รายละเอียดารจัดการค่าธรรมเนียม",
    "NORMAL_FEE_TITLE": "ค่าธรรมเนียมทั่วไป/ตั้งต้น",
    "NORMAL_FEE_TITLE_DETAIL_TITLE": "รายละเอียดค่าธรรมเนียมทั่วไป",
    "MASTER_FEE__FEE_RATE_TITLE": "กำหนดอัตราค่าธรรมเนียม (Pattern)",
    "MASTER_FEE__FEE_RATE_DETAIL_TITLE": "รายละเอียดอัตราค่าธรรมเนียมการศึกษา",
    "MASTER_FEE__FEE_NAME_TH": "ชื่อค่าธรรมเนียม(ไทย)",
    "MASTER_FEE__FEE_NAME_EN": "ชื่อค่าธรรมเนียม(อังกฤษ)",
    "MASTER_FEE__FEE_NAME_PATTERN_TH": "ชื่อค่าธรรมเนียม Pattern (ไทย)",
    "MASTER_FEE__FEE_NAME_PATTERN_EN": "ชื่อค่าธรรมเนียม Pattern (อังกฤษ)",
    "MASTER_FEE__FEE_TYPE": "ประเภทค่าธรรมเนียม",
    "MASTER_FEE__FEE_DESCRIPTION": "คำอธิบาย",
    //form validation
    "VALIDATION__REQUIRED": "กรุณากรอกข้อมูล",
    "VALIDATION__REQUIRED_IF": "กรุณากรอกข้อมูล",
    "VALIDATION__REQUIRED_IF_VALUE": "กรุณากรอกข้อมูล",
    "VALIDATION__LENGTH_GENERAL": "ข้อมูลไม่ถูกต้อง",
    //page scholarship
    "SCHOLARSHIP__ADD": "เพิ่ม ทุนการศึกษา",
    "SCHOLARSHIP__NAME_TH": "ชื่อทุนการศึกษา ภาษาไทย",
    "SCHOLARSHIP__NAME_EN": "ชื่อทุนการศึกษา ภาษาอังกฤษ",
    "SCHOLARSHIP__TYPE_OF_FUNDING": "ประเภทแหล่งทุน",
    "SCHOLARSHIP__NAME_OF_FUNDING": "ชื่อแหล่งทุน",
    "SCHOLARSHIP__ERP_CODE_FUNDING": "ERP_CODE ที่ให้ทุน",
    "SCHOLARSHIP__TYPE": "ประเภท",
    "SCHOLARSHIP__CLEMENT": "ทำผ่อนผัน",
    "SCHOLARSHIP__CAN_CHOOSE": "ผู้รับทุนเลือกเองได้",
    "SCHOLARSHIP__IMPRESSION": "แสดงในใบเสร็จรับเงิน",//"การแสดงผล",
    "SCHOLARSHIP__IMPRESSION_OPDC": "การแสดงผลรายงาน กพร.",
    "SCHOLARSHIP__PAYBACK_SCHOLARSHIP": "ทุนที่ต้องใช้คืน",
    "SCHOLARSHIP__ONLY_ONE_SCHOLARSHIP": "รับได้แค่ทุนนี้ทุนเดียว",
    "SCHOLARSHIP__SCHOLARSHIP_DETAILS": "รายละเอียดทุน",
    "SCHOLARSHIP__SCHOLARSHIP_CODE": "รหัสทุนการศึกษา",
    "SCHOLARSHIP__ADD_DETAILS_HEADER": "เพิ่ม รายละเอียดทุนการศึกษา/ส่วนลด",
    "SCHOLARSHIP__AMOUNT_DISCOUNT": "ส่วนลดเป็นจำนวนเงิน",
    "SCHOLARSHIP__PERCENT_DISCOUNT": "ส่วนลดเป็น %",
    "SCHOLARSHIP__TYPE_OF_SCHOLARSHIP": "ประเภทการให้ทุน",
    "SCHOLARSHIP__DETAILS_OF_SCHOLARSHIP": "รายละเอียดของทุน",
    "SCHOLARSHIP__FUNDRAISING": "การให้ทุน",
    "SCHOLARSHIP__LIST_OF_FUNDERS": "รายชื่อผู้ได้รับทุน",
    "SCHOLARSHIP__FUNDRAISING_DETAILS": "รายละเอียดการให้ทุน",
    "SCHOLARSHIP__ADD_FUNDRAISING_DETAILS": "เพิ่ม รายละเอียดการให้ทุนการศึกษา",
    "SCHOLARSHIP__DETAIL": "รายละเอียดทุนการศึกษา",
    "SCHOLARSHIP__DELETE_DATA_SUCCESS": "ลบรายละเอียดทุนการศึกษาสำเร็จ",
    "SCHOLARSHIP__EDIT_DETAILS_HEADER": "แก้ไข รายละเอียดทุนการศึกษา/ส่วนลด",
    "SCHOLARSHIP__ADD_DETAIL_SUCCESS": "เพิ่มรายละเอียดทุนการศึกษาสำเร็จ",
    "COMMON__YES": "ใช่",
    "COMMON__NO": "ไม่",
    "COMMON__SHOW": "แสดง",
    "COMMON__DO_NOT_SHOW": "ไม่แสดง",
    "COMMON__ACCEPT": "เลือกรับ",
    "COMMON__DO_NOT_ACCEPT": "ไม่เลือกรับ",
    "COMMON__RECORD_STATUS": "สถานะการใช้งาน",
    "COMMON__ADD_DETAILS": "เพิ่มรายละเอียด",
    "COMMON__RECORD_STATUS_ACTIVE": "ใช้งาน",
    "COMMON__RECORD_STATUS_INACTIVE": "ไม่ใช้งาน",
    "COMMON__PLEASE_ADD_DETAILS": "กรุณากดเพิ่มรายละเอียด",
    "COMMON__IMPORT_LIST": "Import รายชื่อ",
    "COMMON__CREATED_BY": "ผู้สร้างรายการ",
    "COMMON__UPDATED_DT": "วันที่แก้ไขล่าสุด",
    "COMMON__UPDATED_BY": "ผู้แก้ไข",
    "COMMON__CF_DELETE_DATA": "กรุณายืนยัน ต้องการลบข้อมูล",
    "COMMON__OR_NOT": "หรือไม่",
    "COMMON__DELETE_DATA": "ลบข้อมูล",
    "COMMON__ALL_RESULTS": "ผลการค้นหาทั้งหมด",
    "COMMON__ITEMS": "รายการ",
    "COMMON__UPDATED_BY_": "ผู้แก้ไขรายการ",
    "COMMON__CANNOT_BE_PROCRESS": "ขออภัยไม่สามารถดำเนินการได้ในขณะนี้",
    "COMMON__TITLE_ADD_DATA": "เพิ่มข้อมูล",
    "COMMON__CF_ADD_DATA": "กรุณายืนยัน ต้องการเพิ่มข้อมูล",
    "COMMON__TITLE_EDIT_DATA": "ยืนยันการแก้ไข",
    "COMMON__CF_EDIT_DATA": "กรุณายืนยัน ต้องการแก้ไขข้อมูล",
    "ENROLL_STATUS_ITEMS": "รายการ",
    "MSG__STD_STATUS_DISCOUNT": "การลงทะเบียนขอรับสิทธิ์ลดหย่อน ภาคปลาย ปีการศึกษา  2564",
    "MSG__STD_STATUS_DISCOUNT_2": "ภาคปลาย ปีการศึกษา 2564",
    "MSG__STD_STATUS_DISCOUNT_CF": "คลิกที่นี่เพื่อไปหน้าหลักส่วนลด",
    "MSG__STD_STATUS_DISCOUNT_CC": "ยกเลิก",
    "MSG__STD_STATUS_DISCOUNT_LINK": "คลิกที่นี่เพื่อไปหน้าหลักส่วนลด",
    "MENU__STUDENT_DISCOUNTS": "ส่วนลดนิสิต",
    "FINSTD__DISCOUNT_NOT_FOUND": "ไม่พบข้อมูลทุน/ส่วนลด",
    "FINSTD__PLEASE_SELECT_DISCOUNT": "กรุณาเลือกทุน/ส่วนลดของ",
    "FINSTD__CONFIRM_SELECT_DISCOUNT": "ยืนยันการเลือกทุน/ส่วนลด",
    "FINSTD__SELECT_DISCOUNT_DATE_START": "เลือกรับทุน/ส่วนลดได้ตั้งแต่วันที่ ",
    "FINSTD__SELECT_DISCOUNT_DATE_END": "ถึงวันที่ ",
    "FINSTD__MOBILE_DATE_SELECT_DISCOUNT": "กำหนดรับ ",
    "FINSTD__SELECT_DISCOUNT_SUCCESS": "เลือกรับทุน/ส่วนลดสำเร็จ",
    "FINSTD__CONFIRM_CANCEL_SELECT_DISCOUNT": "ยกเลิกการรับทุน/ส่วนลด",
    "FINSTD__CANCEL_DISCOUNT_SUCCESS": "ยกเลิกการรับทุน/ส่วนลดสำเร็จ",
    "FINSTD__CANCEL_DISCOUNT_UNSUCCESS": "ยกเลิกการรับทุน/ส่วนลดไม่สำเร็จ",

    "TRN_STUDYSOURCE_LABEL" : "สถาบันต้นทาง",
    "TRN_STUDYSOURCE_IN" : "ม.เกษตรศาสตร์",
    "TRN_STUDYSOURCE_OUT" : "ม.อื่นๆ",
    "TRN_TARGET_STUDENT" : "เลือกข้อมูลผลการเรียนจากรหัสนิสิต",
    "TRN_SELECT_UNIVERSITY" : "เลือกสถาบันต้นทาง",

    "GRD_VALUE_ALL": "ทั้งหมด",

    "COMMON_YOU_CAN_LOG_IN_WITH" : "เฉพาะผู้ดูแลระบบ",
    "COMMON_MORE_DETAIL": "หากท่านมีข้อสงสัย หรือต้องการสอบถามรายละเอียดข้อมูล"
}
